import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Chip,
    ListItemButton,
    Stack,
    Toolbar,
    Typography
} from '@mui/material';
import {useLocation, useNavigate} from "react-router-dom";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DateRangeIcon from '@mui/icons-material/DateRange';
import HistoryIcon from '@mui/icons-material/History';
import React, {Fragment, useContext} from "react";
import {AuthContext, useStickyState} from "@lb/mlib-components";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Header from "./Header";
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import StraightenIcon from '@mui/icons-material/Straighten';
import FaceIcon from '@mui/icons-material/Face';
import PrintIcon from '@mui/icons-material/Print';
import SubjectIcon from '@mui/icons-material/Subject';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import {CardGiftcard, HowToReg, LocalMallOutlined, LocalShipping} from "@mui/icons-material";
import SsidChartIcon from '@mui/icons-material/SsidChart';
import LocalShippingTwoToneIcon from '@mui/icons-material/LocalShippingTwoTone';
import {titleCase} from "../../utils/titleCase";
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import EventIcon from '@mui/icons-material/Event';
import AssessmentIcon from '@mui/icons-material/Assessment';

export const drawerWidth = 240;

const MyDrawer = ({callLoad}) => {

    const navigate = useNavigate();

    const location = useLocation();

    const authCtx = useContext(AuthContext);
    const {version} = window['runConfig'];

    const {build} = window['runConfig'];

    const [expandedAudit, setExpandedAudit] = useStickyState(false, 'ziggyExpandedAudit');

    function handleChange() {
        setExpandedAudit(!expandedAudit);
    }

    const [expandedProduction, setExpandedProduction] = useStickyState(false, 'ziggyExpandedProduction');

    function handleChangeProduction() {
        setExpandedProduction(!expandedProduction);
    }

    const [expandedReporting, setExpandedReporting] = useStickyState(false, 'ziggyExpandedReporting');

    function handleChangeReporting() {
        setExpandedReporting(!expandedReporting);
    }

    const [expandedShipping, setExpandedShipping] = useStickyState(false, 'ziggyExpandedShipping');

    function handleChangeShipping() {
        setExpandedShipping(!expandedShipping);
    }

    const [expandedSettings, setExpandedSettings] = useStickyState(false, 'ziggyExpandedSettings');

    function handleChangeSettings() {
        setExpandedSettings(!expandedSettings);
    }

    function MyListButton({path, title, children, beta}) {
        return <>
            <ListItemButton selected={location.pathname === path} onClick={() => {
                navigate(path)
            }}
                            activeClassName="Mui-selected">
                <ListItemIcon>
                    {children}
                </ListItemIcon>
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <ListItemText primary={title || titleCase({value: path.slice(1, path.length)})}/>
                    {beta && <><Chip label={'BETA'}
                                     size={"small"}
                                     variant={"outlined"}/></>}
                </Stack>
            </ListItemButton>
        </>;
    }

    return (
        <Fragment>
            <Box sx={{display: 'flex'}}>
                <CssBaseline/>

                <Header callLoad={callLoad}/>

                {authCtx.isLoggedIn() && (
                    <Drawer
                        variant="permanent"
                        sx={{
                            width: drawerWidth,
                            flexShrink: 0,
                            [`& .MuiDrawer-paper`]: {width: drawerWidth, boxSizing: 'border-box'},
                        }}
                    >

                        <Toolbar/>

                        <Box flexGrow={1} sx={{overflow: 'auto'}}>

                            <Accordion square disableGutters elevation={0}
                                       expanded={expandedShipping} onChange={handleChangeShipping}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <ListItemIcon>
                                        <LocalShippingIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Shipping"/>

                                </AccordionSummary>
                                <><Divider/>
                                    <AccordionDetails>

                                        <MyListButton path={'/prepare'}><ShoppingCartIcon/></MyListButton>
                                        <MyListButton path={'/fulfilment'}><SubjectIcon/></MyListButton>
                                        <MyListButton path={'/scheduler'}><DateRangeIcon/></MyListButton>
                                        <MyListButton path={'/forpickup'}
                                                      title={'For Pickup'}><ShoppingBagIcon/></MyListButton>
                                        <MyListButton path={'/transit'}><LocalShippingTwoToneIcon/></MyListButton>
                                        <Divider/>
                                        <MyListButton path={'/history'}><HistoryIcon/></MyListButton>

                                    </AccordionDetails>
                                </>
                            </Accordion>
                            {expandedProduction && <Divider/>}
                            <Accordion square disableGutters elevation={0}
                                       expanded={expandedProduction} onChange={handleChangeProduction}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <ListItemIcon>
                                        <PrecisionManufacturingIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Production"/>

                                </AccordionSummary>
                                <><Divider/>
                                    <AccordionDetails>
                                        <MyListButton path={'/production'}
                                                      title={'Orders'}><ShoppingCartOutlinedIcon/></MyListButton>

                                        <MyListButton path={'/stockitems/stock'}
                                                      title={'Stock'}><InventoryOutlinedIcon/></MyListButton>
                                        <MyListButton title={'Reconcile'}
                                                      path={'/production/reconcile'}><CleaningServicesIcon/></MyListButton>

                                        <MyListButton beta path={'/production/quality'}
                                                      title={'Quality'}><AutoGraphIcon/></MyListButton>
                                        <MyListButton path={'/production/qchold'}
                                                      title={'QC Hold'}><HowToReg/></MyListButton>
                                    </AccordionDetails>
                                </>
                            </Accordion>
                            {expandedReporting && <Divider/>}

                            <Accordion square disableGutters elevation={0}
                                       expanded={expandedReporting} onChange={handleChangeReporting}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <ListItemIcon>
                                        <AssessmentIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Reporting"/>

                                </AccordionSummary>
                                <><Divider/> <AccordionDetails>
                                    <MyListButton path={'/sampleorders'}
                                                  title={'Sample Orders'}><LocalMallOutlined/></MyListButton>
                                    <MyListButton path={'/finance'}><SsidChartIcon/></MyListButton>
                                    <MyListButton path={'/logistics'}><LocalShipping/></MyListButton>
                                </AccordionDetails>
                                </>
                            </Accordion>
                            {expandedAudit && <Divider/>}

                            <Accordion square disableGutters elevation={0}
                                       expanded={expandedAudit} onChange={handleChange}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <ListItemIcon>
                                        <FactCheckIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Audit"/>

                                </AccordionSummary>
                                <><Divider/> <AccordionDetails>

                                    <MyListButton path={'/audit/salesorders'}
                                                  title={'Sales Orders'}><ShoppingCartOutlinedIcon/></MyListButton>
                                    <MyListButton path={'/audit/shipments'}
                                                  title={'Shipment'}><CardGiftcard/></MyListButton>

                                    <MyListButton path={'/audit/warehouse'}
                                                  title={'Warehouse'}><WarehouseOutlinedIcon/></MyListButton>

                                    <MyListButton path={'/audit/lbship/expected'}
                                                  title={'LB Ship'}><LocalShippingTwoToneIcon/></MyListButton>
                                    {build === "Development" && <MyListButton path={'/audit/clone'}
                                                                              title={'Clone'}><ContentCopyIcon/></MyListButton>}
                                    {/*<MyListButton path={'/dashboard/today'}
                                                  title={'Dashboard'}><DashboardIcon/></MyListButton>*/}

                                </AccordionDetails></>
                            </Accordion>
                            {expandedSettings && <Divider/>}
                            <Accordion square disableGutters elevation={0}
                                       expanded={expandedSettings} onChange={handleChangeSettings}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon/>}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <ListItemIcon>
                                        <SettingsIcon/>
                                    </ListItemIcon>
                                    <ListItemText primary="Settings"/>

                                </AccordionSummary>
                                <><Divider/>

                                    <AccordionDetails>
                                        <List>

                                            {build ==='Development' && <MyListButton path={'/freeitems'}
                                                           title={'Free Items'}><CardGiftcard/></MyListButton>}
                                            <MyListButton path={'/couriers'}><LocalShippingOutlinedIcon/></MyListButton>
                                            <MyListButton path={'/dims'}><StraightenIcon/></MyListButton>
                                            <MyListButton path={'/stations'}><FaceIcon/></MyListButton>
                                            <MyListButton path={'/printers'}><PrintIcon/></MyListButton>
                                            <MyListButton path={'/trackers'}><VideoLabelIcon/></MyListButton>
                                            <MyListButton path={'/targets'}><CrisisAlertIcon/></MyListButton>
                                            <MyListButton path={'/holidays'}><EventIcon/></MyListButton>

                                        </List>

                                    </AccordionDetails></>
                            </Accordion>

                            <Divider/>

                        </Box>

                        <Typography variant='caption' align='right' paddingX={1}>
                            {version.toLowerCase()}
                        </Typography>
                    </Drawer>
                )} </Box>


        </Fragment>

    );
};

export default MyDrawer;

